/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Import_ExternalInputs */



/**
* | output |
* | --- |
* | "Importing project file from external data..." |
*
* @param {Load_Project_File_Status_Import_ExternalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_import_external = /** @type {((inputs?: Load_Project_File_Status_Import_ExternalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Import_ExternalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du fichier projet depuis des donnees externes...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importiere Projektdatei aus externen Daten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del file di progetto da dati esterni...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт файла проекта из внешних источников данных...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando archivo de proyecto desde datos externos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从外部数据源导入项目文件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("外部データからプロジェクト ファイルをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाह्य डेटा से प्रोजेक्ट फ़ाइल आयात की जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando arquivo de projeto de dados externos...")
	return /** @type {LocalizedString} */ ("Importing project file from external data...")
});